import {deleteUser} from "@project/sdk/admin";
import {mutationOptions} from "@tanstack/react-query";

import {userMutationKeys} from "../../user-keys";

/**
 * Mutation option factory for deleting a user.
 *
 * Declares the mutationKey (for DevTools + setMutationDefaults targeting) and
 * the mutationFn. Optimistic logic (onMutate / onError / onSettled) belongs in
 * the UI layer alongside useQueryClient().
 *
 * Usage in a component:
 *   const mutation = useMutation({
 *     ...deleteUserMutationOptions(),
 *     onMutate: async (id) => { ... },
 *   });
 */
export function deleteUserMutationOptions() {
  return mutationOptions({
    mutationFn: (id: string) => deleteUser(id),
    mutationKey: userMutationKeys.delete(),
  });
}
